import { ModuleCompletionSelectionType } from '../enums/module-completion-selection-type.enum';
import { IChangeProgramCompletionForParticipantsActionPayload } from '../interfaces/change-program-completion-for-participants.action.payload.interface';
import { IModuleCompletionFilters } from '../interfaces/module-completion-filters.interface';

export class ChangeProgramCompletionForParticipantsCommand {
    selection_type: ModuleCompletionSelectionType;
    user_ids?: number[];
    status: 'not_started' | 'in_progress' | 'completed';
    filters?: IModuleCompletionFilters;

    constructor(query: IChangeProgramCompletionForParticipantsActionPayload) {
        this.selection_type = query.selection_type;
        this.status = query.status;

        if (query.user_ids?.length) {
            this.user_ids = query.user_ids.map((userId) => Number(userId));
        }

        if (query.filters && Object.keys(query.filters).length) {
            this.filters = query.filters;
        }
    }
}
